import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutProspectType } from "./autogen/AutogenLayoutProspectType";

export class ProspectType extends AutogenLayoutProspectType {
    onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "prospect_type",
            screenName: this.titleSingular,
            navigateToUrl: `${this.layoutName}?mode=update&key=`
        });
    }
}